export const USER_DEPOSIT_TYPES = {
    INCREASE: { value: "INCREASE", text: "입금" },
    DECREASE: { value: "DECREASE", text: "출금" },
};
/** @typedef {keyof typeof USER_DEPOSIT_TYPES} UserDeposit_Type */
